export default __webpack_public_path__ + "static/media/PTImage.440cf6491651b121b430a1ca8270cce1.webp";